export default __webpack_public_path__ + "static/media/processPersonal.f76ee1af.png";